import { createApiClient } from "../shared/lib/createApiClient"

const api = createApiClient()

export const describeCars = () => api.get("/api/vehicles/describe")

export const fetchCars = (page, pageSize) =>
    api.get("/api/vehicles", { params: { page, pageSize } })

export const fetchAllCars = () => api.get("/api/vehicles", { params: { all: true } })

export const fetchCarById = (id) => api.get(`/api/vehicles/${id}`)

export const fetchSimilarCars = (id, limit = 8) =>
    api.get(`/api/vehicles/${id}/similar`, { params: { limit } })

export const describeFAQs = (query = "") =>
    api.get("/api/faqs/describe", { params: { q: query || undefined } })

export const fetchFAQs = (page, pageSize, query = "") =>
    api.get("/api/faqs", { params: { page, pageSize, q: query || undefined } })

export const sendMessage = (name, email, phone, message, carName, sessionId) =>
    api.post("/api/enquiries", { name, email, phone, message, carName, sessionId })

export default api
